import * as Http from "./Http.Client";

export const checkoutComplet = (data,isAuth) => {
    return Http.Put(`api/v1/order/checkout`, {}, data,isAuth)
        .then(result => result ? result : false);
};
export const tipTarif = () => {
    return Http.Get(`api/v1/order/tip/tariffs`, {}, )
        .then(result => result ? result : false);
};